import React, { useState, useEffect } from "react";
import axios from "axios";

import { AvForm, AvField } from "availity-reactstrap-validation";
import SimpleBar from "simplebar-react";
import Select from "react-select";
import customStyles from "../../../../assets/select/customStyles";
import {useTranslation} from "react-i18next";

const CreateEditUserDepartment = ({entryId, entryChanged}) => {
    const { t } = useTranslation();
    const link = localStorage.getItem('link') + '/api/UserDepartments';
    const [parkingscenarios, setParkingscenarios] = useState([]);

    const [entry, setEntry] = useState({});
    const [failShow, setFailShow] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const newEntry = !(entryId > 0);

    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
    useEffect(() => {
        loadData();
    }, [entryId]);

    const loadData = () => {
        axios.get(link + '/byid?id=' + (entryId ?? ''), {}).then((response) => {
            console.debug(response.data);
            
            setParkingscenarios(response.data.parkingScenarios);

            setEntry(response.data.entry);
        })
        .catch((error) => {
            console.error("Error while loading Data", error);
        });
    }

    function handleValidSubmit() {
        setFailShow(false);

        if (entry.availableReservationsPerDay === "") {
            entry.availableReservationsPerDay = null;
        }
        if (entry.maximalLenghtOfReservationInDays === "") {
            entry.maximalLenghtOfReservationInDays = null;
        }
        
        console.debug(entry);
        axios
        ({
            method: newEntry ? 'post' : 'put',
            url: link,
            data: entry,
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                entryChanged();
            })
            .catch((error) => {
                console.error(error);
                setErrorMessage(error.message);
                setFailShow(true);
            });
    }

    return (
        <SimpleBar style={{width: "100%", height: "100%"}}>
            <div style={{width: "30%", margin: "auto"}}>
                <div style={{ marginTop: "20px" }}>
                    <h3>
                        {newEntry ? t("administration.userDepartments.create") : t("administration.userDepartments.edit")}
                    </h3>
                    <AvForm
                        className="form-horizontal"
                        onValidSubmit={() => {
                            handleValidSubmit();
                        }}
                    >
                        <div className="form-group">
                            <AvField
                                style={{ height: "25px" }} className="form-control"
                                name="name"
                                required={true}
                                label={t("administration.userDepartments.name") + ":"}
                                value={entry?.name ?? ''}
                                onChange={(e) => {
                                    setEntry(prev => ({...prev, name: e.target.value}));
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <AvField
                                style={{ height: "25px" }} className="form-control"
                                name="name"
                                type="number"
                                required={false}
                                label={t("administration.userDepartments.availableReservationsPerDay") + ":"}
                                value={entry?.availableReservationsPerDay ?? ''}
                                onChange={(e) => {
                                    setEntry(prev => ({...prev, availableReservationsPerDay: e.target.value ?? null}));
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <AvField
                                style={{ height: "25px" }} className="form-control"
                                name="maximalLenghtOfReservationInDays"
                                type="number"
                                required={false}
                                label={t("administration.userDepartments.maximalLenghtOfReservationInDays") + ":"}
                                value={entry?.maximalLenghtOfReservationInDays ?? ''}
                                onChange={(e) => {
                                    setEntry(prev => ({...prev, maximalLenghtOfReservationInDays: e.target.value ?? null}));
                                }}
                            />
                        </div>

                        <div className="form-group">
                            <div>{t("administration.userDepartments.restrictedToScenario")}</div>
                            <Select
                                styles={customStyles}
                                closeMenuOnSelect={true}
                                isSearchable={false}
                                isMulti={true}
                                onChange={(scenarios) => {
                                    setEntry(prev => ({...prev, restrictedToScenarioId: scenarios?.map((s) => s.value) ?? null, restrictedToScenarios: scenarios ?? null}));
                                }}
                                options={parkingscenarios}
                                value={entry?.restrictedToScenarios}
                            />
                        </div>

                        {failShow === true && (
                            <div
                                className="login-fail"
                                style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    fontSize: "100%",
                                }}
                            >
                                {errorMessage}
                            </div>
                        )}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "20px",
                                marginBottom: "20px",
                            }}
                        >
                            <button
                                type="submit"
                                className="button"
                                style={{ width: "100px" }}
                                onClick={() => entryChanged()}
                            >
                                {t("allgemein.abbruch")}
                            </button>
                            <button
                                type="submit"
                                className="button"
                                style={{ marginLeft: "10px", width: "100px" }}
                            >
                                {t("allgemein.speichern")}
                            </button>
                        </div>
                    </AvForm>
                </div>
            </div>
        </SimpleBar>
    );
};

export default CreateEditUserDepartment;
